import React from 'react';
import { connect } from 'react-redux';

import OrganizationBasicSettings from './OrganizationBasicSettings';
import OrganizationGaSettings from './OrganizationGaSettings';
import Error from '../../components/Error';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import * as organizationConstants from '../../constants/organizations';
import * as organizationSettingsSelectors from '../../selectors/organizationSettingsSelectors';
import isAuthorizedCurrentOrganization from '../../hoc/CurrentOrganizationAuthorization';

class OrganizationSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    onClose = () => {
        this.setState({ open: false });
        this.props.onReset();
    };

    componentDidUpdate({ loading: wasLoading }) {
        const { loading, error } = this.props;
        if (wasLoading && !loading && !error) {
            this.onClose();
        }
    }

    render() {
        const { onSubmit, loading, isFormValid, error, gaError } = this.props;
        const { open } = this.state;
        return (
            <React.Fragment>
                <Dialog open={open} onClose={this.onClose}>
                    <DialogTitle>Settings</DialogTitle>
                    <DialogContent>
                        <OrganizationBasicSettings />
                        <OrganizationGaSettings />
                        <Error>{error}</Error>
                        <Error>{gaError}</Error>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onClose}>CANCEL</Button>
                        <Button
                            onClick={onSubmit}
                            variant="contained"
                            color="primary"
                            disabled={loading || !isFormValid}
                        >
                            {loading ? 'UPDATING' : 'UPDATE'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    loading: organizationSettingsSelectors.getIsLoading(state),
    error: organizationSettingsSelectors.getError(state),
    gaError: organizationSettingsSelectors.getGaError(state),
    isFormValid: organizationSettingsSelectors.getIsFormValid(state),
});

const mapDispatchToProps = dispatch => ({
    onSubmit: () => {
        dispatch({
            type: organizationConstants.UPDATE_ORGANIZATION_SETTINGS_REQUEST,
        });
    },
    onReset: () => {
        dispatch({
            type: organizationConstants.RESET_ORGANIZATION_SETTINGS,
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(isAuthorizedCurrentOrganization(OrganizationSettings, true));



// WEBPACK FOOTER //
// ./src/containers/organizationSettings/OrganizationSettings.js